/**
 * Resolve `{0}` / `{1}` placeholders from resource strings.
 *
 * @param {string} pattern
 * @param {number} current
 * @param {number} total
 * @returns {string}
 */
export function formatCarouselLabel(pattern, current, total) {
	return String(pattern || '')
		.replace('{0}', String(current))
		.replace('{1}', String(total));
}

/**
 * Apply disabled/focusability state to a navigation button.
 *
 * @param {HTMLButtonElement|null} button
 * @param {boolean} disabled
 */
export function setCarouselButtonDisabled(button, disabled) {
	if (!button) {
		return;
	}

	button.disabled = disabled;
	button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
	if (disabled) {
		button.setAttribute('tabindex', '-1');
	} else {
		button.removeAttribute('tabindex');
	}
}

/**
 * Sync previous/next button state for non-loop carousels.
 *
 * @param {import('swiper').default} swiper
 * @param {HTMLButtonElement|null} prevButton
 * @param {HTMLButtonElement|null} nextButton
 */
export function syncNonLoopCarouselNavState(swiper, prevButton, nextButton) {
	setCarouselButtonDisabled(prevButton, swiper.isBeginning);
	setCarouselButtonDisabled(nextButton, swiper.isEnd);
}

/**
 * Update an aria-live region with the current slide position.
 *
 * @param {Element|null} liveEl
 * @param {string} pattern
 * @param {number} activeIndex
 * @param {number} total
 */
export function updateCarouselLiveRegion(liveEl, pattern, activeIndex, total) {
	if (!liveEl) {
		return;
	}

	liveEl.textContent = formatCarouselLabel(pattern, activeIndex + 1, total);
}

/**
 * Add aria-labels to Swiper-generated pagination bullets.
 *
 * @param {Element} root
 * @param {string} paginationSelector
 * @param {string} pattern
 * @param {number} total
 */
export function decorateCarouselPagination(root, paginationSelector, pattern, total) {
	root.querySelectorAll(paginationSelector + ' .swiper-pagination-bullet').forEach(function (bullet, index) {
		bullet.setAttribute('aria-label', formatCarouselLabel(pattern, index + 1, total));
		bullet.setAttribute('role', 'button');
		if (!bullet.hasAttribute('tabindex')) {
			bullet.setAttribute('tabindex', '0');
		}
	});
}
